var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTooling = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.369 14.619A1.406 1.406 0 0 1 1.38 12.63l3.977-3.975 1.989 1.989zM11.985 3.981 6.351 9.615M13.374 3.951a.937.937 0 1 1-1.325-1.326L13.706.969l1.325 1.325zM6.9 5.576 5.467 4.142a2.34 2.34 0 0 0-.523-2.513 2.32 2.32 0 0 0-1.4-.66A1.87 1.87 0 0 1 .969 3.548a2.325 2.325 0 0 0 3.17 1.919l.985.985M9.393 10.723l1.109 1.109a2.343 2.343 0 1 0 1.325-1.326l-1.568-1.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.682 12.92a.234.234 0 1 1 0-.469M12.682 12.92a.235.235 0 0 0 0-.469"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    stroke: stroke
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.369 14.619A1.406 1.406 0 0 1 1.38 12.63l3.977-3.975 1.989 1.989zM11.985 3.981 6.351 9.615M13.374 3.951a.937.937 0 1 1-1.325-1.326L13.706.969l1.325 1.325zM6.9 5.576 5.467 4.142a2.34 2.34 0 0 0-.523-2.513 2.32 2.32 0 0 0-1.4-.66A1.87 1.87 0 0 1 .969 3.548a2.325 2.325 0 0 0 3.17 1.919l.985.985M9.393 10.723l1.109 1.109a2.343 2.343 0 1 0 1.325-1.326l-1.568-1.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.682 12.92a.234.234 0 1 1 0-.469M12.682 12.92a.235.235 0 0 0 0-.469"
  }))));
});
export default SvgIconTooling;
export const raw = __webpack_public_path__ + "static/media/IconTooling.3ef18d104a43e192eeaf3bdb908857c7.svg";